var map = {
	"./close.svg": "7710",
	"./download.svg": "4dae",
	"./medical.svg": "d3a9",
	"./next.svg": "6e7d",
	"./play.svg": "fb4f",
	"./report.svg": "9e5c",
	"./search.svg": "8e8d",
	"./sticker-1.svg": "0c5f",
	"./sticker-2.svg": "ba4d",
	"./sticker-3.svg": "93b1",
	"./time.svg": "3add",
	"./to.svg": "f009",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";